/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopChannel } from './TopChannel';
import {
    TopChannelFromJSON,
    TopChannelFromJSONTyped,
    TopChannelToJSON,
    TopChannelToJSONTyped,
} from './TopChannel';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface TopChannelsData
 */
export interface TopChannelsData {
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof TopChannelsData
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {Array<TopChannel>}
     * @memberof TopChannelsData
     */
    topChannels?: Array<TopChannel>;
}

/**
 * Check if a given object implements the TopChannelsData interface.
 */
export function instanceOfTopChannelsData(value: object): value is TopChannelsData {
    return true;
}

export function TopChannelsDataFromJSON(json: any): TopChannelsData {
    return TopChannelsDataFromJSONTyped(json, false);
}

export function TopChannelsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopChannelsData {
    if (json == null) {
        return json;
    }
    return {
        
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'topChannels': json['topChannels'] == null ? undefined : ((json['topChannels'] as Array<any>).map(TopChannelFromJSON)),
    };
}

export function TopChannelsDataToJSON(json: any): TopChannelsData {
    return TopChannelsDataToJSONTyped(json, false);
}

export function TopChannelsDataToJSONTyped(value?: TopChannelsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'topChannels': value['topChannels'] == null ? undefined : ((value['topChannels'] as Array<any>).map(TopChannelToJSON)),
    };
}

